/*
  Shared coordination for POUFF's custom-coded newsletter popups (corner
  sticky, assets/pouff-newsletter-popup.js, and full-screen,
  assets/pouff-newsletter-popup-fullscreen.js).

  Both popups sell the same thing (10% off for an email) and must never be
  allowed to show at the same time, and closing/subscribing to one must
  suppress the other too — otherwise a visitor could see both, or dismiss
  one only to have the other pop up right after. This file is the single
  source of truth for that shared state, loaded by both popup scripts
  before their own init runs (see layout/theme.liquid).

  - localStorage keys persist across page loads: "closed" suppresses for N
    days, "subscribed" suppresses forever.
  - window.__pouffPopupActive is an in-memory mutex for same-pageview
    conflicts: whichever popup's trigger fires first claims it, so the
    other skips itself for that pageview rather than stacking on top.
*/
(function () {
  if (window.PouffNewsletterPopups) return;

  var CLOSED_AT_KEY = 'pouffNewsletterClosedAt';
  var SUBSCRIBED_KEY = 'pouffNewsletterSubscribed';
  var FULLSCREEN_SHOWS_KEY = 'pouffFullscreenShows';
  var FULLSCREEN_SESSION_KEY = 'pouffFullscreenShownThisSession';
  var VISITOR_ID_KEY = 'pouffKlaviyoVisitorId';
  var EVENTS_ENDPOINT = 'https://a.klaviyo.com/client/events';
  var REVISION = '2026-07-15';

  function isSubscribed() {
    try {
      return window.localStorage.getItem(SUBSCRIBED_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function isSuppressedByRecentClose(suppressDays) {
    try {
      var closedAt = window.localStorage.getItem(CLOSED_AT_KEY);
      if (!closedAt) return false;
      var elapsedMs = Date.now() - parseInt(closedAt, 10);
      return elapsedMs < suppressDays * 24 * 60 * 60 * 1000;
    } catch (e) {
      return false;
    }
  }

  function markClosed() {
    try {
      window.localStorage.setItem(CLOSED_AT_KEY, String(Date.now()));
    } catch (e) {}
  }

  function markSubscribed() {
    try {
      window.localStorage.setItem(SUBSCRIBED_KEY, '1');
    } catch (e) {}
  }

  // Red full-screen popup visit counter: it shows once per browsing session
  // up to a cap, then the corner popup takes over (see the corner script).
  function getFullscreenShows() {
    try {
      return parseInt(window.localStorage.getItem(FULLSCREEN_SHOWS_KEY), 10) || 0;
    } catch (e) {
      return 0;
    }
  }

  function recordFullscreenShow() {
    try {
      window.localStorage.setItem(FULLSCREEN_SHOWS_KEY, String(getFullscreenShows() + 1));
      window.sessionStorage.setItem(FULLSCREEN_SESSION_KEY, '1');
    } catch (e) {}
  }

  function fullscreenShownThisSession() {
    try {
      return window.sessionStorage.getItem(FULLSCREEN_SESSION_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function onCartPage() {
    return /\/cart(\/|$)/.test(window.location.pathname);
  }

  // Same-pageview mutex: the popup that triggers first claims it; the
  // other checks this immediately before showing and bails out if taken,
  // rather than stacking two popups in front of the visitor.
  function claim() {
    if (window.__pouffPopupActive) return false;
    window.__pouffPopupActive = true;
    return true;
  }

  function release() {
    window.__pouffPopupActive = false;
  }

  // See assets/pouff-newsletter-popup.js history (2026-09-30) for why this
  // posts directly to Klaviyo's public Events API with a self-generated
  // external_id, rather than window.klaviyo.track() (confirmed to silently
  // no-op) or an email-only identified event (confirmed to 202 then be
  // silently dropped for a brand-new address).
  function getVisitorId() {
    try {
      var id = window.localStorage.getItem(VISITOR_ID_KEY);
      if (!id) {
        id = 'pnp-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
        window.localStorage.setItem(VISITOR_ID_KEY, id);
      }
      return id;
    } catch (e) {
      return null;
    }
  }

  function trackEvent(companyId, eventName) {
    if (!companyId) return;
    try {
      fetch(EVENTS_ENDPOINT + '?company_id=' + encodeURIComponent(companyId), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          revision: REVISION
        },
        body: JSON.stringify({
          data: {
            type: 'event',
            attributes: {
              properties: {},
              metric: { data: { type: 'metric', attributes: { name: eventName } } },
              profile: { data: { type: 'profile', attributes: { external_id: getVisitorId() } } }
            }
          }
        })
      }).catch(function () {});
    } catch (e) {}
  }

  window.PouffNewsletterPopups = {
    isSubscribed: isSubscribed,
    isSuppressedByRecentClose: isSuppressedByRecentClose,
    markClosed: markClosed,
    markSubscribed: markSubscribed,
    getFullscreenShows: getFullscreenShows,
    recordFullscreenShow: recordFullscreenShow,
    fullscreenShownThisSession: fullscreenShownThisSession,
    onCartPage: onCartPage,
    claim: claim,
    release: release,
    trackEvent: trackEvent
  };
})();
